import React from "react";
import classNames from "classnames";
import { Dropdown } from "react-bootstrap";
import { RiMoreFill } from "@remixicon/react";
import { Permission } from "../../../__generated__/api";
import { TicketItem } from "../../../contexts/ticket-state";
import useCurrentSession from "../../../contexts/session";
import EditMessageAction from "./edit";
import DeleteMessageAction from "./delete";
import RescheduleMessageAction from "./reschedule";
import SendNowMessageAction from "./send-now";
import Styles from "../Chat.module.scss";

interface ScheduledCardActionsProps {
    messageText: string;
    isHover?: boolean;
    messageId: string;
    ticketItem?: TicketItem;
    scheduledDate: Date;
}

export default function ScheduledCardActions({
    messageText, isHover, messageId, ticketItem, scheduledDate,
}: ScheduledCardActionsProps) {
    const { permissions } = useCurrentSession();
    const className = classNames(Styles["card-action"], Styles["card-action-agent"], Styles["card-action-horizontal"], {
        [Styles["card-action-hover"]]: isHover,
    });

    if (!permissions.has(Permission.ChatsModifyAll)) {
        return null;
    }

    return (
        <div className={className}>
            <Dropdown show>
                <Dropdown.Menu className={Styles["menu-container"]}>
                    <EditMessageAction ticketMessageId={messageId} iconOnly />
                    <RescheduleMessageAction date={scheduledDate} ticketMessageId={messageId} ticketItem={ticketItem} iconOnly />
                    <SendNowMessageAction ticketMessageId={messageId} ticketItem={ticketItem} iconOnly />
                    <DeleteMessageAction text={messageText} ticketMessageId={messageId} ticketItem={ticketItem} isScheduled iconOnly />
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
}

ScheduledCardActions.defaultProps = {
    isHover: true,
    ticketItem: undefined,
};
